module.exports = __webpack_public_path__ + "0993c3f5ea50471738853b6dc9b6a03c.pdf";